var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mini-button',{attrs:{"loading":_vm.downloading,"name":"导出"},on:{"btnClick":_vm.whenExportClick}},[_c('i',{staticClass:"fa-solid fa-file-export"})])
}
var staticRenderFns = []

export { render, staticRenderFns }